import React from 'react';
import store from './store/store';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import './reset.css';
import Layout from './Layout';
// import reportWebVitals from '../reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Layout />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
